import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router'

@Component({
  selector: 'app-company-step',
  templateUrl: './company-step.component.html',
  styleUrls: ['./company-step.component.scss']
})
export class CompanyStepComponent {
  @Input() formGroup!: FormGroup;
  @Output() saveAndNext = new EventEmitter<void>();
  @Output() discard = new EventEmitter<void>();
  showLogoUpload = false


  countries = [
    { code: 'IN', name: 'India' },
    { code: 'US', name: 'United States' },
    { code: 'UK', name: 'United Kingdom' },
    { code: 'SG', name: 'Singapore' },
    { code: 'AU', name: 'Australia' }
  ];

  constructor(private router: Router) {
  }

  get f() {
    return this.formGroup.controls
  }

  handleFileInput(files: any) {
    this.formGroup.patchValue({ logoFile: files });
  }

  clearSelectedFiles(event: any) {
    this.formGroup.patchValue({ logoFile: null });
  }

  exit() {
    this.router.navigate(['/settings'])
  }
}
